import { Component, EventEmitter, Input, OnInit, Output, effect} from '@angular/core';
// import {alertGroupItems} from './direct-alert-settings.constants';
import {
    DisplayDirectAlertSettings,
    DisplayGroupList,
    GroupInfo,
    SeverityOptionModel,
} from '../models/direct-alert-settings.model';
import { AlertNotificationService } from '../services/alert-notification.service';
import { displayAlertCodes } from '../enums/alert_codes.enum';
import { Router } from '@angular/router';
import { DisplayCategory } from '../enums/display-category.enum';
import { TranslateService } from '@ngx-translate/core';
import { HelperService, IdentifierService, ToasterClass } from 'merlin-core';
import {
    PopupConfig,
    PopupService,
    PopupType,
    SpinnerService,
} from 'merlin-library';
import { EnrollPatientDeviceDataService } from '../services/enroll-patient-device-data.service';
import { EnrollPatientTransmitterService } from '../services/enroll-patient-transmitter.service';
import { PatientListService } from '../services/patient-list.service';
import { MatDialog } from '@angular/material/dialog';
import { ReleasePatientDialogComponent } from '../release-patient-dialog/release-patient-dialog.component';
import { UserProfileObject, UserService } from 'merlin-library';
import { LocalizationService, ReturnType } from 'src/core/utilitites/localization.service';
import { ToastrService } from 'ngx-toastr';
import { FunctionMode } from '../manual-patient-enroll/enums/enroll-patient.enum';
import { PatientProfilePrintDialogComponent } from '../patient-profile-print-dialog/patient-profile-print-dialog.component';
import { UntypedFormGroup } from '@angular/forms';
import { AVEIR_ALL_CODES } from '../manual-patient-enroll/patient-device-data/device-transmit-information/device-codes.constants';

@Component({
    selector: 'app-direct-alerts-notifications',
    templateUrl: './direct-alerts-notifications.component.html',
    styleUrls: ['./direct-alerts-notifications.component.scss'],
    standalone: false
})
export class DirectAlertsNotificationsComponent implements OnInit {
    displayAlertGroup: DisplayDirectAlertSettings[] = [];
    defaultAlertDetails = [];
    overRideAlertDetails = [];
    severityOptions: SeverityOptionModel[] = [];
    displayAlertDetails = [];
    displayGroup: DisplayGroupList[] = [];
    isOverride = false;
    isClickedOnRemoveOverride: boolean = false;
    disableSelectAllCheckBox: boolean = false;
    toggleDisplayFlg = false;
    displayAlertGroupList: GroupInfo[] = [];
    alertInfo: DisplayDirectAlertSettings = new DisplayDirectAlertSettings();
    displayGroupCategoryCdOptions: SeverityOptionModel[] = [];
    durationList = [];
    bivthresholdList = [];
    rvthresholdList = [];
    subCategoryGroup = [];
    subCategoryGroupDuplicates = [];
    toggleSubCategory = true;
    patientOverridesMap: Map<any, any>;
    @Input() patientId: number;
    @Output() navBackward = new EventEmitter();
    @Output() navForward = new EventEmitter();
    patientRecordSymptomTxFlg: any;
    clinicRecordSymptomTxFlg: any;
    effectiveRecordSymptomTxFlg: any;
    overrideClicked: boolean = false;
    isICMDevice: boolean;
    isNGQDevice: boolean;
    isAveirDevice: boolean;
    isSP2CanEnroll: boolean;
    showRecordSymDialogue: boolean = false;
    bluetoothCapable: boolean;

    @Input('functionMode') functionMode: string;
    displayMode = 'view';
    hasPatientDataEntryAccess: boolean = false;
    patRes;
    batterAdvisoryAlertEnabled: boolean = false;
    transmitterSWVersion = null;
    transmitterSWUpgraded?:boolean;
    transmitterSwNull?:boolean
    fwPBDPatchFlg = null;
    isBatterPerformanceFlgtrue: boolean = false;
    tooltipsAlertCode: number[] = [218, 260, 269, 268, 272];
    isPatientRelease: boolean = false;
    releasePatientMsg: string;
    defaultThreshold;
    defaultDuration;
    formEditFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    activatorClinicFlg: boolean=false;

    public stringLabels = [
        "label.gb.remove_overrides",
        "label.gb.edit",
        "label.gb.button_cancel",
        "label.gb.save",
        "label.gb.print_profile",
        "label.gb.release_patient",
        "label.gb.more_actions",
        "label.gb.reactivate_pat",
        "label.gb.alert_type",
        "label.gb.alert_classification",
        "label.gb.inform_patient",
        "label.gb.instructional_alert_emergency_contact",
        "label.gb.urgent",
        "label.gb.standard",
        "label.gb.dont_select",
        "label.gb.symptom_PA_control",
        "label.gb.instructional_enable_symptom_trans",
        "label.gb.override_instr_text",
        "label.gb.special_alert_note",
        "label.gb.instructional_alert_configuration",
        "label.gb.trans_sw_ver_note",
    ];

    public labels: Record<string, string>;

    public titleLabel;
    public msg893Label;
    public msg894Label;
    public msg895Label;
    public msg896Label;
    
    constructor(
        private alertService: AlertNotificationService,
        private router: Router,
        private translateService: TranslateService,
        public helperService: HelperService,
        public enrollService: EnrollPatientDeviceDataService,
        public transmitterService: EnrollPatientTransmitterService,
        public patientListService: PatientListService,
        public dialog: MatDialog,
        public userService: UserService,
        public localizationService: LocalizationService,
        public toasterService: ToastrService,
        public identifierService: IdentifierService,
        private popupService: PopupService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        }); 
    }
    ngOnDestroy() {
       // alert('you are leaving from DAN with '+ this.formEditFormGroup.dirty)
        this.enrollService.updateDeviceFormDirty(this.formEditFormGroup.dirty);
    }
    ngOnInit() {
        this.translateStrings();
        this.titleLabel = this.getTitle();
        this.msg893Label = this.getMsgText893();
        this.msg894Label = this.getMsgText894();
        this.msg895Label = this.getMsgText895();
        this.msg896Label = this.getMsgText896();
        
        this.getPatRes();
        this.enrollService.updateDeviceFormDirty(false);
        this.userService.getUserProfile(false).subscribe(
            (userData: UserProfileObject) => {
                this.activatorClinicFlg =  userData.activatorClinicFlg;
                this.hasPatientDataEntryAccess = userData?.canEnroll;
                this.isSP2CanEnroll =
                    userData.customerType === 'CL'
                        ? true
                        : userData?.customerType === 'SP2' &&
                        userData?.canEnroll;
            },
            (err) => {
                this.helperService.showErrorToastr(err);
            }
        );
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    getTitle() {
        return this.localizationService.generateLocalizedStr(
            'label.gb.alert_notif',
            null,
            'html'
        );
    }


    getMsgText894(): any {
        return this.localizationService.generateLocalizedStr(
            'msg.pa894.text',
            null,
            'html'
        );
    }

    getMsgText896(): any {
        return this.localizationService.generateLocalizedStr(
            'msg.pa896.text',
            null,
            'html'
        );
    }
    hideAlert() {
        this.batterAdvisoryAlertEnabled = false;
    }

    clinicDefaults: any;

    public getData(overrideClicked?) {
        this.displayAlertGroupList = [];
        this.alertService.getAlertInfo(this.patientId).subscribe(
            (res) => {
                this.clinicDefaults = res.clinicDefaults;
                this.batterAdvisoryAlertEnabled =
                    res?.batterAdvisoryAlertEnabled;
                this.fwPBDPatchFlg = res?.fwPBDPatchFlg;
                this.transmitterSWVersion = res?.transmitterSWVersion;
                this.transmitterSWUpgraded =res?.transmitterSWUpgraded;
                this.transmitterSwNull =res?.transmitterSwNull
                this.updateLocalData(res);
                if(overrideClicked){
                    this.overrideTxReassign(overrideClicked);
                    this.overrideClicked = false;
                }
            },
            (err) => {
                console.log(err);
                this.helperService.showErrorToastr(err);
            }
        );
        this.transmitterService.getTransmitterData(this.patientId).subscribe(
            (res) => {
                this.bluetoothCapable = res.bluetoothCapable;
            },
            (error) => {
                this.helperService.showErrorToastr(error);
            }
        );
    }



    getOverrideInfo(): boolean {

        if (this.displayAlertDetails.length != 0 &&
            this.displayAlertGroupList.length == 0) {

            for (let i = 0; i < this.displayAlertDetails.length; i++) {
                const itemA = this.displayAlertDetails[i];
                if ((itemA.defaultSeverityCd !== itemA.severityCd) || (itemA.defaultDisplayFlg !== itemA.displayFlg)) {
                    return true;
                }
            }
        }
        if (this.displayAlertDetails.length != 0 &&
            this.displayAlertGroupList.length != 0) {
            for (let i = 0; i < this.displayAlertGroupList.length; i++) {
                const itemA = this.displayAlertGroupList[i];
                for(let j=0; j< itemA.groupInfo.length; j++){
                    const itemB = itemA.groupInfo[j];
                    if ((itemB.defaultSeverityCd !== itemB.severityCd) || (itemB.defaultDisplayFlg !== itemB.displayFlg)) {
                        return true;
                    }
                }
            }
        }
        if (this.isICMDevice && (this.clinicRecordSymptomTxFlg !== this.effectiveRecordSymptomTxFlg)) {
            return true;
        }
        return false;
    }
    recordSymptomChange({checked}){
        this.patientRecordSymptomTxFlg = checked;
        this.enrollService.updateDeviceFormDirty(true);
    }
    getMsg2Banner(): boolean {
        return (
            this.batterAdvisoryAlertEnabled &&
            this.fwPBDPatchFlg == null &&
            this.transmitterSWVersion
        );
    }
    hideAlert893() {
        this.batterAdvisoryAlertEnabled = false;
    }

    getMsgText893() {
        return this.localizationService.generateLocalizedStr(
            'msg.pa893.text',
            null,
            'html'
        );
    }

    getMsgText895() {
        return this.localizationService.generateLocalizedStr(
            'msg.pa895.text',
            null,
            'html'
        );
    }

    releasePatient() {
        const patientIds = [this.patientId];

        this.patientListService.getReleasePatientData(patientIds).subscribe(
            (res) => {
                const releasePatientDRef = this.dialog.open(
                    ReleasePatientDialogComponent,
                    {
                        width: '900px',
                        // height:'600px',
                        data: {
                            patients: res.releasePatientSummaryDTO.map((a) => {
                                a.patientInfo['isTransmissionComplete'] =
                                    a.isTransmissionComplete;
                                return a.patientInfo;
                            }),
                            clinicFavoriteDTO: res.clinicFavoriteDTO,
                            releaseReasonCd: res.releaseReasonCd,
                            transferCustApplId: res.transferCustApplId,
                        },
                    }
                );

                releasePatientDRef.afterClosed().subscribe((result) => {

                    if (result.reasonForReasonFlag) {
                        const selectedIds = [this.patientId];
                        let data = {
                            patientIds: selectedIds,
                            releaseReasonCode: result.reasonForReasonFlag,
                            transferCustApplId: result.transferCustApplId
                                ? result.transferCustApplId
                                : '',
                        };
                        this.patientListService
                            .updateReleasePatient(data)
                            .subscribe((response) => {
                                const refTransferCusDetails =
                                    res.clinicFavoriteDTO &&
                                    res.clinicFavoriteDTO.find(
                                        (a) =>
                                            a.associatedCustApplId ===
                                            result.transferCustApplId
                                    );
                                let releasePatient =
                                    this.localizationService.generateLocalizedStr(
                                        'msg.pa834b.text'
                                    );

                                if (refTransferCusDetails) {
                                    releasePatient += ` ${refTransferCusDetails.name} : ${refTransferCusDetails.phoneNum} `;
                                }
                                if (result.reasonForReasonFlag === 'R' &&
                                    result.selectedClinicDetails) {
                                        const phone = `${result.selectedClinicDetails.countryCode}-${result.selectedClinicDetails.areaCode}-${result.selectedClinicDetails.phoneNum}`;
                                        const releaseTxt =  this.activatorClinicFlg ? 'msg.patrel_actclinic.text' : 'msg.patrel_regclinic.text';
                                            releasePatient = result.selectedClinicDetails.customerId !=null
                                             ?
                                             this.translateMsg( releaseTxt,
                                                {
                                                    0: result.selectedClinicDetails.name,
                                                    1: phone,
                                                }, ReturnType.HTML
                                            ) : this.translateMsg('msg.pa834a.text', null, ReturnType.HTML);

                                            this.isPatientRelease = true;
                                            this.releasePatientMsg = releasePatient;

                                    } else{
                                        this.isPatientRelease = false;
                                        this.releasePatientMsg = '';
                                    }

                                if (this.profileMode()) {
                                    this.toasterService.success(
                                        this.localizationService.generateLocalizedStr(
                                            'msg.pa834b.text'
                                        )
                                    );
                                }
                            });
                    }
                });
            },
            (err) => {
                this.helperService.showErrorToastr(err);
            }
        );
    }

    translateMsg(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }

    getText(text: string, index: number): string {
        return index == 0
            ? text.split('{{0}}')[0]
            : index == 1
                ? text.split('{{0}}')[1].split('{{1}}')[0]
                : text.split('{{0}}')[1].split('{{1}}')[1];
    }

    public assignClinicUiValues() {
        this.displayAlertDetails = [];
        if (this.alertInfo?.patientOverrides) {
            this.patientOverridesMap = new Map(
                this.alertInfo.patientOverrides.map((obj) => [
                    obj.alertGroupId,
                    obj,
                ])
            );
            if (this.functionMode === 'profile' &&
                this.displayMode == 'edit') {
                this.alertInfo.clinicDefaults.forEach((clinicDefault) => {
                    const alertGroupId = clinicDefault.alertGroupId;
                    const override = this.patientOverridesMap.get(alertGroupId);
                    if (this.patientOverridesMap.has(alertGroupId)) {
                        clinicDefault.alertHandlingId = override.alertHandlingId;
                        clinicDefault.defaultDisplayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                        clinicDefault.defaultSeverityCd = clinicDefault.severityCd;
                    } else {
                        clinicDefault.defaultSeverityCd = clinicDefault.severityCd;
                        this.defaultThreshold = clinicDefault.threshold;
                        this.defaultDuration = clinicDefault.durationCd;
                        clinicDefault.defaultDisplayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                        clinicDefault.displayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                    }
                    clinicDefault.overrideDisplayFlg = override?.displayFlg
                        ? override.displayFlg
                        : false;
                    if(!(clinicDefault?.alertGroupId == 40 && clinicDefault?.doNotDisplayCongestionMonitoring)){
                        this.displayAlertDetails.push(clinicDefault);
                    }
                });
            } else {
                this.alertInfo.clinicDefaults.forEach((clinicDefault) => {
                    const alertGroupId = clinicDefault.alertGroupId;
                    const override = this.patientOverridesMap.get(alertGroupId);
                    if (this.patientOverridesMap.has(alertGroupId)) {
                        this.isOverride = true;
                        clinicDefault.alertHandlingId = override.alertHandlingId;
                        clinicDefault.defaultDisplayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                        clinicDefault.displayFlg = override?.displayFlg
                            ? override.displayFlg
                            : false;
                        clinicDefault.alertSubCategoryCd =
                            override.alertSubCategoryCd;
                        clinicDefault.alertSubCategoryHeaderCd =
                            override.alertSubCategoryHeaderCd;
                        // clinicDefault.displayGroupCategoryCd =
                        //     override.displayGroupCategoryCd;
                        if (override.durationCd != null) {
                            clinicDefault.durationCd = override.durationCd;
                        }
                        clinicDefault.defaultSeverityCd = clinicDefault.severityCd;
                        clinicDefault.severityCd =
                            override.severityCd != null
                                ? override.severityCd
                                : clinicDefault.severityCd;

                        clinicDefault.threshold =
                            override.threshold != null
                                ? override.threshold
                                : clinicDefault.threshold;
                    } else {
                        clinicDefault.defaultSeverityCd = clinicDefault.severityCd;
                        this.defaultThreshold = clinicDefault.threshold;
                        this.defaultDuration = clinicDefault.durationCd;
                        clinicDefault.defaultDisplayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                        clinicDefault.displayFlg = clinicDefault?.displayFlg
                            ? clinicDefault.displayFlg
                            : false;
                    }
                    clinicDefault.overrideDisplayFlg = override?.displayFlg
                        ? override.displayFlg
                        : false;
                    if(!(clinicDefault?.alertGroupId == 40 && clinicDefault?.doNotDisplayCongestionMonitoring)){
                        this.displayAlertDetails.push(clinicDefault);
                    }
                });
            }

            const list = this.displayAlertDetails.filter((d: any) => {
                return d.alertCode == 272;
            });

            if (list.length > 0) {
                this.isBatterPerformanceFlgtrue = list[0].displayFlg;
            }
        }
        this.displayAlertDetails.forEach((ele) => {
            let code = ele.alertCode.toString();
            ele.alertDesc = this.translate(
                'data.Alert_Group.Description.' + code
            );
            if (ele.alertSubCategoryCd && !ele.alertSubCategoryHeaderCd) {
                this.subCategoryGroupDuplicates.push(ele);
            }
        });
        const selectAllCheckBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg == true || e.severityCd == 988).length;
        (selectAllCheckBoxCount < this.displayAlertDetails?.length) ? (this.toggleDisplayFlg = false) : (this.toggleDisplayFlg = true);
        this.subCategoryGroup = [
            ...new Map(
                this.subCategoryGroupDuplicates.map((item) => [
                    item['alertGroupId'],
                    item,
                ])
            ).values(),
        ];

        this.defaultAlertDetails = this.alertInfo.clinicDefaults;
        const codePriority = ["URG", "STD", "DSL"];
        this.severityOptions = this.sortSeverityOptions(codePriority, this.alertInfo.severityOptions);

        // if (this.displayAlertDetails?.[0]?.displayGroupCategoryCd) {
        this.displayGroupList();
        // }


    }

    sortSeverityOptions = (codePriority, severityOptArray) => {
        return this.helperService.sortSeverityOptions(codePriority, severityOptArray)
    }

    getRollOverText(alertCd: number) {
        let msg = this.localizationService.generateLocalizedStr(
            'data.Code.Alert_Rollover_Text_Cd.Code_Desc.INFO' + alertCd
        );
        return msg.replace(/\\n/g, '<br />');
    }

    reActivatePatient() {
        const patientIds = [this.patientId];
        if (this.hasPatientDataEntryAccess) {
            this.patientListService
                .updateReactivatePatient(patientIds)
                .subscribe(
                    (res) => {
                        this.toasterService.success(
                            this.localizationService.generateLocalizedStr(
                                'msg.pa800b.text',
                                { 0: '1' }
                            )
                        );
                        this.isPatientRelease = false;
                    },
                    (err) => {
                        this.helperService.showErrorToastr(err);
                    }
                );
        }
    }

    public updateLocalData(resource: any) {
        if (resource) {
            this.alertInfo = resource;
            this.bivthresholdList = resource.bivPacingDropdowns;
            this.rvthresholdList = resource.rvPacingDropdowns;
            this.durationList = resource.durationCdOptions;
            this.displayGroupCategoryCdOptions =
                resource.displayGroupCategoryCdOptions;
            this.patientRecordSymptomTxFlg = this.isICMDevice ? resource?.patientRecordSymptomTxFlg : false;
            this.clinicRecordSymptomTxFlg = resource?.clinicRecordSymptomTxFlg;
            if(resource?.patientRecordSymptomTxFlg !== null){
                this.effectiveRecordSymptomTxFlg = this.isICMDevice ? resource?.patientRecordSymptomTxFlg : false;
            } else {
                this.effectiveRecordSymptomTxFlg = resource?.clinicRecordSymptomTxFlg;
            }
            this.assignClinicUiValues();

            const selectAllCheckBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg == true || e.severityCd == 988).length;
            const isAllCheckDisable = this.displayAlertDetails?.filter(e => e.severityCd == 988).length;
            (selectAllCheckBoxCount <= this.displayAlertDetails?.length) ? (this.toggleDisplayFlg = false) : (this.toggleDisplayFlg = true);
            (isAllCheckDisable == this.displayAlertDetails?.length) ? this.disableSelectAllCheckBox = true : this.disableSelectAllCheckBox = false;
        }
    }

    public displayGroupList() {
        this.displayAlertDetails.forEach((ele) => {
            const res =
                this.displayAlertGroupList &&
                this.displayAlertGroupList.find(
                    (a) =>
                        a.displayGroupCategoryCd === ele.displayGroupCategoryCd
                );

            if (res) {
                this.displayAlertGroupList.forEach((e) => {
                    if (
                        e.displayGroupCategoryCd === ele.displayGroupCategoryCd
                    ) {
                        const exist = e.groupInfo.filter(
                            (d) => d.alertGroupId === ele.alertGroupId
                        );
                        if (exist.length == 0) {
                            e.groupInfo.push(ele);
                        }
                    }
                });
            } else {
                let temp: GroupInfo = new GroupInfo();
                temp.displayGroupCategoryCd = ele.displayGroupCategoryCd;
                this.displayGroupCategoryCdOptions.forEach((p) => {
                    if (p.codeId === temp.displayGroupCategoryCd) {
                        const data = Object.keys(DisplayCategory).filter(x => x === p.code);
                        temp.displayName = data.length ? DisplayCategory[data[0]] : '';
                    }
                });
                temp.groupInfo.push(ele);
                if (temp.displayGroupCategoryCd != null) {
                    this.displayAlertGroupList.push(temp);
                    this.parseAlertGroupListLabels(this.displayAlertGroupList);
                }
            }
        });
    }

    parseAlertGroupListLabels(alertGroupList){
        let stringToAppend = [];
        for(let alert of alertGroupList){
            stringToAppend.push(alert.displayName)
        }
        console.log(stringToAppend);
        this.appendStringsToLabelList(stringToAppend);
    }

    public severityChange(e, alert) {
        this.toggleDisplayFlg = false
        this.isOverride = true;
        if (alert.alertDesc == 'LeadAssurance™ Alert') {
            this.toggleSubCategory = false;
        }
        //  if (e === 988) {
        this.displayAlertDetails.forEach((a) => {
            if (a.alertHandlingId === alert.alertHandlingId) {
                if (e === 988) {
                    a.displayFlg = false;
                }
            }
        });
        if (alert.alertSubCategoryCd && alert.alertSubCategoryHeaderCd) {
            this.subCategoryGroup.forEach((p) => {
                p.severityCd = e;
                if (e === 988) {
                    p.displayFlg = false;
                }
            });
        }
        //  }
        let highestCategoryCode = null;
        if (
            alert.alertSubCategoryCd &&
            alert.alertSubCategoryHeaderCd == null
        ) {
            let LeadAssuranceAlertIndex = this.displayAlertDetails.findIndex(
                (alt) => alt.alertGroupId == 55
            );
            if (e === 934) {
                highestCategoryCode = 934;
            }
            if (e === 935) {
                highestCategoryCode = 935;
                for (let p of this.subCategoryGroup) {
                    if (
                        p.severityCd == 934 &&
                        p.alertGroupId != alert.alertGroupId
                    ) {
                        highestCategoryCode = 934;
                        break;
                    }
                }
            }
            if (e === 988) {
                highestCategoryCode = 988;
                for (let p of this.subCategoryGroup) {
                    if (
                        p.severityCd == 934 &&
                        p.alertGroupId != alert.alertGroupId
                    ) {
                        highestCategoryCode = 934;
                        break;
                    }
                    if (
                        p.severityCd == 935 &&
                        p.alertGroupId != alert.alertGroupId
                    ) {
                        highestCategoryCode = 935;
                    }
                }
            }

            this.displayAlertDetails[LeadAssuranceAlertIndex].severityCd =
                highestCategoryCode;
        }
        const checkBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg != e.defaultDisplayFlg).length;
        const checkRadioButtonCount = this.displayAlertDetails?.filter(ele => ((ele.alertHandlingId === alert.alertHandlingId && (ele.defaultSeverityCd != e)) || (ele.alertHandlingId != alert.alertHandlingId && ele.severityCd != ele.defaultSeverityCd))).length
        if (checkRadioButtonCount > 0 || checkBoxCount > 0) {
            this.isOverride = true;
            this.functionMode = 'profile'
        } else {
            this.isOverride = false;
        }
        this.enrollService.updateDeviceFormDirty(true);
        const selectAllCheckBoxCount = this.displayAlertDetails?.filter(ele => ele.displayFlg == true || ((ele.alertHandlingId === alert.alertHandlingId && e == 988) || (ele.severityCd == 988 && ele.alertHandlingId !== alert.alertHandlingId))).length;
        (selectAllCheckBoxCount <= this.displayAlertDetails?.length) ? (this.toggleDisplayFlg = false) : (this.toggleDisplayFlg = true);

        const isAllCheckDisable = this.displayAlertDetails?.filter(ele => (((ele.alertHandlingId === alert.alertHandlingId && e == 988) || (ele.severityCd == 988 && ele.alertHandlingId !== alert.alertHandlingId)))).length;

        (isAllCheckDisable == this.displayAlertDetails?.length) ? this.disableSelectAllCheckBox = true : this.disableSelectAllCheckBox = false;
    }

    public removeOverride() {
        this.isOverride = false;
        this.overrideClicked = true;
        this.getData(this.overrideClicked);
    }
    overrideTxReassign( overrideClicked:boolean) {
        this.patientRecordSymptomTxFlg = null;
        this.effectiveRecordSymptomTxFlg = this.clinicRecordSymptomTxFlg;
    }

    public back() {
        this.navBackward.emit('back');
    }

    public cancel() {
        this.router.navigate(['/patient-list']);
    }
    getAlertDialogRef(message: string, type: PopupType) {
        const msg = this.localizationService.generateLocalizedStr(
            message,
            null,
            'html'
        );
        const dialogConfig: PopupConfig = {
            type: type,
            message: msg,
            confirmText:
                this.localizationService.generateLocalizedStr('label.gb.ok'),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.localizationService.generateLocalizedStr(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    public save() {
        if (
            this.functionMode === 'profile' &&
            this.displayMode === 'edit' &&
            !this.formEditFormGroup.dirty &&
            !this.isClickedOnRemoveOverride
        ) {
            this.displayMode = 'view';
            return;
        }
        if (this.isICMDevice && !this.effectiveRecordSymptomTxFlg) {
            const dialogConfigSuccess: PopupConfig = this.getAlertDialogRef(
                'msg.pa889.text',
                PopupType.Confirm
            );
            this.popupService.open(dialogConfigSuccess);
            this.popupService.confirmed().subscribe((confirmationx) => {
                if (confirmationx) {
                    this.updateData();
                }
            });
        } else {
            this.updateData();
        }
    }
    updateData() {
        let alertInfo = this.alertInfo;
        let newOverrides = [];

        if (this.displayAlertDetails?.length > 0  && this.displayAlertGroupList.length == 0) {
            this.displayAlertDetails.forEach((d) => {
                const alertGroupId = d.alertGroupId;
                let override = this.patientOverridesMap.get(alertGroupId);
                if (override && override.severityCd !== d.severityCd) {
                    override.severityCd = d.severityCd;
                    override.displayFlg = d.displayFlg;
                    override.threshold = d.threshold;
                    override.durationCd = d.durationCd;
                    newOverrides.push(override);
                } else if (
                    d.severityCd !== d.defaultSeverityCd ||
                    d.displayFlg !== false
                ) {
                    newOverrides.push(d);
                } else {
                    newOverrides.push(d);
                }
            });
        }

        if (this.displayAlertDetails?.length > 0  && this.displayAlertGroupList?.length > 0) {
            this.displayAlertGroupList.forEach((e) => {
                e.groupInfo.forEach((g) => {
                    const alertGroupId = g.alertGroupId;
                    let override = this.patientOverridesMap.get(alertGroupId);
                    if (override && override.severityCd !== g.severityCd) {
                        override.severityCd = g.severityCd;
                        override.displayFlg = g.displayFlg;
                        newOverrides.push(g);
                    } else if (
                        g.severityCd !== g.defaultSeverityCd ||
                        g.displayFlg !== false
                    ) {
                        newOverrides.push(g);
                    }
                });
            });
        }


        // if (this.subCategoryGroup?.length) {
        //     this.subCategoryGroup.forEach((s) => {
        //         const alertGroupId = s.alertGroupId;
        //         let override = this.patientOverridesMap.get(alertGroupId);
        //         if (override && override.severityCd !== s.severityCd) {
        //             override.severityCd = s.severityCd;
        //             override.displayFlg = s.displayFlg;
        //             newOverrides.push(s);
        //         } else if (
        //             s.severityCd !== s.defaultSeverityCd ||
        //             s.displayFlg !== false
        //         ) {
        //             newOverrides.push(s);
        //         }
        //     });
        // }
        alertInfo.patientOverrides = newOverrides;
        alertInfo.patientRecordSymptomTxFlg = this.patientRecordSymptomTxFlg;
        alertInfo["triggerPatConf"] = null;
        this.alertService.updateAlertInfo(this.patientId, alertInfo).subscribe(
            (res) => {
                if (this.functionMode !== FunctionMode.ENROLL) {
                    let successMsg =
                        this.localizationService.generateLocalizedStr(
                            'msg.cs830.text'
                        );
                    // this.toasterService.success(successMsg);
                    if (this.formEditFormGroup.valid) {
                        this.toasterService.show(successMsg, null, {
                            enableHtml: true,
                            toastClass: `${ToasterClass.userNotificationMessageB} ${ToasterClass.ngxToastr}`,
                        });
                    }
                }
                this.formEditFormGroup.markAsPristine();
                this.displayMode = 'view';
                this.enrollService.updateDeviceFormDirty(false);
                res.patientOverrides.forEach((record) => {
                    if (!record.severityCd) {
                        const defaultData = res.clinicDefaults.find((data) => {
                            if (data.alertGroupId === record.alertGroupId) {
                                return data;
                            }
                        });
                        record.severityCd = defaultData.severityCd;
                    }
                });
                this.updateLocalData(res);
            },
            (err) => {
                this.formEditFormGroup.markAsPristine();
                console.log(err);
                this.helperService.showErrorToastr(err);
            }
        );
    }

    changeEditFormDirty() {
        if (!this.formEditFormGroup.dirty) {
            this.formEditFormGroup.markAsDirty();
        }
    }

    public toggleDisplay(e) {
        this.displayAlertDetails.forEach((alert) => {
            if (alert.severityCd !== 988) {
                if (alert.notifyPatientUiInactiveFlg) {
                    alert.displayFlg = e;
                }
            }
        });
        this.isOverride = true;

        const checkRadioButtonCount = this.displayAlertDetails?.filter(ele => ele.severityCd != ele.defaultSeverityCd).length;
        const checkBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg != e.defaultDisplayFlg).length;
        if (checkBoxCount > 0 || checkRadioButtonCount > 0) {
            this.isOverride = true;
            this.functionMode = 'profile'
        } else {
            this.isOverride = false;
        }
        // this.isOverride = true;

    }

    public displayChange(e, alert) {

        this.isOverride = true;
        if (alert.alertSubCategoryCd && alert.alertSubCategoryHeaderCd) {
            this.subCategoryGroup.forEach((p) => {
                //  p.severityCd = e;
                if (
                    !this.severityCodeDisable(
                        p.severityCd,
                        p.notifyPatientUiInactiveFlg
                    )
                ) {
                    p.displayFlg = e;
                }
            });
            this.displayAlertDetails.forEach((ele) => {
                if (ele.alertSubCategoryHeaderCd) {
                    ele.displayFlg = e;
                }
            });
        } else {
            this.displayAlertDetails.forEach((ele) => {
                if (ele.alertGroupId == alert.alertGroupId) {
                    ele.displayFlg = e;
                }
            });
            if(alert.alertSubCategoryCd) {
                let LeadAssuranceAlertIndex = this.displayAlertDetails.findIndex(
                    (alt) => alt.alertGroupId == 55
                );
                let res = false;
                this.subCategoryGroup.forEach((p) => {
                    res = res || p.displayFlg;
                });
                this.displayAlertDetails[LeadAssuranceAlertIndex].displayFlg = res;
            }
            //   alert.displayFlg = e;
        }
        const checkRadioButtonCount = this.displayAlertDetails?.filter(ele => ele.severityCd != ele.defaultSeverityCd).length;
        const checkBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg != e.defaultDisplayFlg).length;
        if (checkBoxCount > 0 || checkRadioButtonCount > 0) {
            this.isOverride = true;
            this.functionMode = 'profile'
        } else {
            this.isOverride = false;
        }
        const selectAllCheckBoxCount = this.displayAlertDetails?.filter(ele => ele.displayFlg == true || ((ele.alertHandlingId === alert.alertHandlingId && e == 988) || (ele.severityCd == 988 && ele.alertHandlingId !== alert.alertHandlingId))).length;
        (selectAllCheckBoxCount < this.displayAlertDetails?.length) ? (this.toggleDisplayFlg = false) : (this.toggleDisplayFlg = true);


        this.enrollService.updateDeviceFormDirty(true);
    }

    public compareThreshold(o1, o2) {
        return o1 === o2;
    }

    profileMode() {
        return this.functionMode === 'profile';
    }

    viewMode() {
        return this.displayMode === 'view';
    }

    editMode() {
        return this.displayMode === 'edit';
    }

    setDisplayMode(value: string) {
        if (value == 'edit') {
            const severityOff = this.displayAlertDetails?.filter(e => e.severityCd == 988).length;
            const selectAllCheckBoxCount = this.displayAlertDetails?.filter(e => e.displayFlg == true || e.severityCd == 988).length;
            (selectAllCheckBoxCount == this.displayAlertDetails?.length && severityOff != this.displayAlertDetails?.length) ? (this.toggleDisplayFlg = true) : (this.toggleDisplayFlg = false);
        }
        this.displayMode = value;
    }

    cancelEditClick() {
        if (this.enrollService.isDeviceFormDirty) {
            // const dialogConfig: PopupConfig = {
            //     type: PopupType.Confirm,
            //     message: this.localizationService.generateLocalizedStr('msg.cs834.text'),
            //     confirmText:
            //         this.localizationService.generateLocalizedStr(
            //             'label.gb.ok'
            //         ),
            //     confirmId: this.identifierService.buttonId(
            //         'pcs-location-popup',
            //         'Ok'
            //     ),
            //     cancelId: this.identifierService.buttonId(
            //         'pcs-location-popup',
            //         'cancel001'
            //     ),
            //     cancelText: this.localizationService.generateLocalizedStr(
            //         'label.gb.button_cancel'
            //     ),
            //     customPopup: true,
            // };
            // this.popupService.open(dialogConfig);
            // this.popupService.dialogRef
            //     .afterClosed()
            //     .subscribe((response: any) => {
            //         if (response) {
            //             if (this.functionMode === FunctionMode.ENROLL) {
            //                 this.router.navigate(['patient-list']);
            //             } else {
                            this.getData();
                            this.setDisplayMode('view');
                            this.enrollService.updateDeviceFormDirty(false);
                //         }
                //     }
                // });
        } else {
            this.setDisplayMode('view');
            this.toggleDisplayFlg = false;
            this.getData();
            this.enrollService.updateDeviceFormDirty(false);
        }
    }

    disableCheckBox(notifyPatientUiInactiveFlg = true, alerts?) {
        if (this.functionMode === 'enroll') {
            return false;
        } else if (
            this.functionMode === 'profile' &&
            this.displayMode === 'edit'
        ) {
            return this.isICMDevice ? (alerts?.alertCode === 2006 ? !this.effectiveRecordSymptomTxFlg :
             !notifyPatientUiInactiveFlg) : !notifyPatientUiInactiveFlg;
        } else {
            return !(
                this.functionMode === 'profile' && this.displayMode === 'edit'
            );
        }
    }

    severityCodeDisable(code, notifyPatientUiInactiveFlg) {
        if (code === 988) {
            return true;
        }
        if (this.functionMode === 'enroll') {
            return false;
        } else if (
            this.functionMode === 'profile' &&
            this.displayMode === 'edit'
        ) {
            return !notifyPatientUiInactiveFlg;
        } else {
            return !(
                this.functionMode === 'profile' && this.displayMode === 'edit'
            );
        }
        this.enrollService.updateDeviceFormDirty(true);
    }

    removeOverrideButtonDisplay() {
        this.isClickedOnRemoveOverride = true;
        if (this.functionMode === 'enroll') {
           return this.getOverrideInfo();
        } else if (this.functionMode === 'profile') {
            if (this.displayMode === 'edit') {
                return this.getOverrideInfo();
            }else{
                return false;
            }
        } else {
            return false;
        }
    }
    openPrintDialog() {
        const dialogRef = this.dialog.open(PatientProfilePrintDialogComponent, {
            data: {
                patientid: this.patientId,
                patRes: this.patRes,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }
    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key);
    }
    getPatRes() {

        this.enrollService
            .getDeviceData(this.functionMode, this.patientId.toString())
            .subscribe(
                (res) => {
                    this.patRes = res;
                    let ngqDev = this.patRes.clinicDetails.ngqProdIds.split(",");
                    this.isNGQDevice=ngqDev.indexOf(String(res.patientDevices?.[0]?.productId)) != -1;
                    this.isICMDevice = res?.patientDevices?.[0]?.isICMDevice || false;
                    this.isAveirDevice = res?.patientDevices?.[0]?.isAveirDevice || false;
                    this.getData();
                },
                (err) => {
                    console.log(err);
                }
            );
    }
    isDescriptionElentsDisplay(desc: string): boolean {
        return desc !== '*Congestion Duration Exceeded Programmed Threshold';
    }
}
